import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Row } from "reactstrap";
import { H6, P } from "../../../AbstractElements";
import {
  TaskHeadings1,
  TaskHeadings2,
  TaskData1,
  TaskData2,
  TaskHeadings3,
} from "../../../Data/Booking/BookingDetails";
import moment from "moment";
import { getUserRole } from "../../../Services/Shared.service";
import { VendorAgent } from "../../../Data/SideMenu/RouteMapping";

const BookingDetails = ({ bookingObj }) => {
  const userRole = getUserRole();
  const Table1Data = TaskHeadings1.map((element, i) => {
    let value = bookingObj[element.value] ? bookingObj[element.value] : "-";
    if ((element.value == "createdOn" || element.value == "pickUpDateTime") && value != "-") {
      value = moment(value).format("MMM DD,YYYY HH:mm");
    }
    if(element.value == "packageName" && value == "-"){
      value = 'Based on kilometers'
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  });

  const Table2Data = TaskHeadings2.map((element, i) => {
    let value = bookingObj[element.value] ? bookingObj[element.value] : "-";
    if (element.value == "pickUpDateTime" && value != "-") {
      value = moment(value).format("MMM DD,YYYY HH:mm");
    }
    if (element.value == "paymentModeType" && value == "Cash") {
      value = 'Postpaid'
    }
    if (element.value == "paymentModeType" && value == "CreditCustomer") {
      value = 'Prepaid (CreditCustomer)'
    }
    if (element.value == "paymentModeType" && value == "CreditCard") {
      value = 'Prepaid'
    }
    if ((element.value == "estimatedFare" && value != "-") || (element.value == "discountAmount" && value != "-") || (element.value == "discountedEstimateFare" && value != "-")) {
      value = `Rs ${value}`
    }
    if(userRole.some((userElement) => userElement === VendorAgent) && element.value === "remark" && value != "-")
    {
      const wordsAfterBalance = value.split(" ").filter((word, index) => {
        return index >= value.split(" ").indexOf("Balance");
      });

      value = wordsAfterBalance.join(" ")
    }

    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  });

  const Table3Data = TaskHeadings3.map((element, i) => {
    let value = bookingObj[element.value] ? bookingObj[element.value] : "-";
    if (element.value == "pickUpDateTime" && value != "-") {
      value = moment(value).format("MMM DD,YYYY HH:mm");
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  });
  return (
    <Card className="driver-trip-details">
      <CardBody>
        <Row>
          <div className="table-responsive">
            <table className="booking-list-table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>{Table1Data}</tbody>
            </table>
          </div>
          <div className="table-responsive">
            <table className="booking-list-table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>{Table2Data}</tbody>
            </table>
          </div>
          <div className="table-responsive">
            <table className="booking-list-table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>{Table3Data}</tbody>
            </table>
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default BookingDetails;
